import { Deserializable } from './deserializable';
import { BaseModel } from './base.model';
import { ZoneModel } from './zone.model';

export class CountryModel extends BaseModel implements Deserializable {

  // columns
  country_code: string; // tslint:disable-line: variable-name
  country_name: string; // tslint:disable-line: variable-name
  prio: number | null;

  // relations
  zones: Array<ZoneModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // zones
    let zones = null;
    if (this.zones !== null && this.zones !== undefined) {
      zones = [];
      this.zones.forEach((zone: ZoneModel) => {
        zones.push(new ZoneModel().deserialize(zone));
      });
    }
    this.zones = zones;
    return this;
  }

}
